import { render, staticRenderFns } from "./PricingMobileEdu.vue?vue&type=template&id=7b29c41a&scoped=true&"
import script from "./PricingMobileEdu.vue?vue&type=script&lang=js&"
export * from "./PricingMobileEdu.vue?vue&type=script&lang=js&"
import style0 from "./PricingMobileEdu.vue?vue&type=style&index=0&id=7b29c41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b29c41a",
  null
  
)

export default component.exports